import React, { FC, memo } from 'react';
import { PlatformLinkingProvider, PlatformType } from '@okletsplay/core';

interface LinkingProviderFormatProps {
  platformType?: PlatformType;
}

const PROVIDER_NAMES: Partial<Record<PlatformLinkingProvider | string, string>> = {
  [PlatformLinkingProvider.Steam]: 'Steam',
  [PlatformLinkingProvider.LeagueOfLegends]: 'League of Legends',
  [PlatformLinkingProvider.Lichess]: 'Lichess',
  [PlatformLinkingProvider.Lidraughts]: 'Lidraughts',
  [PlatformLinkingProvider.EvIo]: 'Ev.io',
};

const LinkingProviderFormatComponent: FC<LinkingProviderFormatProps> = ({ platformType }) => {
  if (!platformType) {
    return null;
  }

  return <>{PROVIDER_NAMES[platformType] ?? platformType}</>;
};

export const LinkingProviderFormat = memo(LinkingProviderFormatComponent);
